export default __webpack_public_path__ + "63629d58e418233ca65038a5a2f4ee60.png";